import { BILLING_OPERATIONAL_API } from './apiPaths.js';

/**
 * Canonical print actions — identical HTTP contracts in both shells.
 */
export const PRINT_ACTIONS = {
  INVOICE: {
    method: 'POST',
    pathTemplate: `${BILLING_OPERATIONAL_API.OP_COUNTER}/print/invoices/{invoiceId}`,
    mimeType: 'application/pdf',
    label: 'Print invoice',
  },
  RECEIPT: {
    method: 'POST',
    pathTemplate: `${BILLING_OPERATIONAL_API.OP_COUNTER}/print/receipts/{receiptId}`,
    mimeType: 'application/pdf',
    label: 'Print receipt',
  },
  DAY_CLOSE: {
    method: 'POST',
    pathTemplate: `${BILLING_OPERATIONAL_API.DAY_CLOSE}/print`,
    mimeType: 'application/pdf',
    label: 'Print day close',
  },
  LAB_REPORT: {
    method: 'GET',
    pathTemplate: '/api/v1/lab/print/reports/{reportId}',
    mimeType: 'application/pdf',
    label: 'Print lab report',
  },
  RADIOLOGY_REPORT: {
    method: 'GET',
    pathTemplate: '/api/v1/radiology/print/reports/{reportId}',
    mimeType: 'application/pdf',
    label: 'Print radiology report',
  },
  PHARMACY_ISSUE: {
    method: 'POST',
    pathTemplate: '/api/v1/pharmacy/print/issue/{issueId}',
    mimeType: 'application/pdf',
    label: 'Print pharmacy issue',
  },
};

export function resolvePrintPath(template, params) {
  let path = template;
  for (const [key, value] of Object.entries(params ?? {})) {
    path = path.replace(`{${key}}`, encodeURIComponent(String(value)));
  }
  return path;
}

export function openPdfBlob(blob, title = 'document') {
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank', 'noopener');
  if (!win) {
    const a = document.createElement('a');
    a.href = url;
    a.download = `${title}.pdf`;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
